import React, { Suspense } from 'react';
import './CreateVoteTemplate.css';


const CreateVoteTemplate = ({ title, icon, template, setTemplate }) => {
    const IconComponent = React.lazy(() =>
        import(`../../../assets/icons/votingTemplates/${icon}.svg`).then((module) => {
            return ({
                default: (props) => <img src={module.default} alt={props.title} />,
            });
        }, (err) => ({
            default: (props) => <img src={undefined} alt={`icon '${icon}' not found`} />,
        }))
    );


    return (
        <div className='create-vote-template-top' onClick={() => setTemplate(template)}>
            <div className='create-vote-template-icon'>
                <Suspense fallback={<div>Loading...</div>}>
                    <IconComponent />
                </Suspense>
            </div>
            <div className='create-vote-template-title'>
                {title}
            </div>
        </div>
    );
};

export default CreateVoteTemplate;